
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M13.49 5.48001C14.59 5.48001 15.49 4.58001 15.49 3.48001C15.49 2.38001 14.59 1.48001 13.49 1.48001C12.39 1.48001 11.49 2.38001 11.49 3.48001C11.49 4.58001 12.39 5.48001 13.49 5.48001ZM10.32 17.48L10.89 14.98L12.99 16.98V21.98C12.99 22.53 13.44 22.98 13.99 22.98C14.54 22.98 14.99 22.53 14.99 21.98V16.34C14.99 15.79 14.77 15.27 14.37 14.89L12.89 13.48L13.49 10.48C14.56 11.72 16.11 12.61 17.85 12.89C18.45 12.98 18.99 12.5 18.99 11.89C18.99 11.4 18.63 10.99 18.14 10.91C16.62 10.66 15.36 9.76001 14.69 8.58001L13.69 6.98001C13.29 6.38001 12.69 5.98001 11.99 5.98001C11.69 5.98001 11.49 6.08001 11.19 6.08001L7.21004 7.76001C6.47004 8.08001 5.99004 8.80001 5.99004 9.61001V11.98C5.99004 12.53 6.44004 12.98 6.99004 12.98C7.54004 12.98 7.99004 12.53 7.99004 11.98V9.58001L9.79004 8.88001L8.19004 16.98L4.27004 16.18C3.73004 16.07 3.20004 16.42 3.09004 16.96V17C2.98004 17.54 3.33004 18.07 3.87004 18.18L7.98004 19C9.04004 19.21 10.08 18.54 10.32 17.48Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-directions-run`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconDirectionsRun

    ```js
    <b-new-b-icon-directions-run />
    ```
</docs>


